import { useCallback } from "react";
import type { ChatMessage } from "@/domain/aiAgent";
import type { IAiAgentRepository } from "@/application/ports/repositories/IAiAgentRepository";

interface UseAiAgentFeedbackOptions {
  aiAgentRepository: IAiAgentRepository;
  sessionId: string;
  setMessages: React.Dispatch<React.SetStateAction<ChatMessage[]>>;
}

export const useAiAgentFeedback = ({
  aiAgentRepository,
  sessionId,
  setMessages,
}: UseAiAgentFeedbackOptions) => {
  const submitFeedback = useCallback(
    (messageId: string, rating: "positive" | "negative", reason?: string, comment?: string) => {
      setMessages((prev) => {
        const msgIndex = prev.findIndex((m) => m.id === messageId);
        if (msgIndex === -1) return prev;

        const assistantMsg = prev[msgIndex];
        if (!assistantMsg?.queryId) return prev;

        let question = "";
        for (let i = msgIndex - 1; i >= 0; i--) {
          const previousMsg = prev[i];
          if (previousMsg?.role === "user") {
            question = previousMsg.content;
            break;
          }
        }

        aiAgentRepository.submitFeedback({
          query_id: assistantMsg.queryId,
          rating,
          reason,
          comment,
          question,
          answer: assistantMsg.content,
          session_id: sessionId,
        });

        const updated = [...prev];
        updated[msgIndex] = { ...assistantMsg, feedback: rating };
        return updated;
      });
    },
    [aiAgentRepository, sessionId, setMessages],
  );

  return { submitFeedback };
};
